import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { deleteBook } from '@/modules/Book/gql/book.gql'
import { SnackType } from '@/interfaces/snack'
import { Book } from '@/modules/Book/interfaces/book'
import BookForm from '@/modules/Book/components/BookForm.vue'
import { showErrors, showNotification } from '@/utils/snack'

@Component({
  components: {
    AppDialog,
    BookForm,
    AppTextSearch
  }
})
export default class BookDialog extends Vue {
  targetBook: Book | null = null

  bookDialog = {
    show: false,
    title: 'New Book',
    disable: false,
    actionType: 'new',
    highlightTitle: ''
  }

  deleteBookDialog = {
    show: false,
    title: 'Delete Book',
    disable: false
  }

  showBookDialog (e: Event, targetBook?: Book) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Book'
    let highlightTitle = ''
    if (targetBook) {
      this.targetBook = targetBook
      actionType = 'edit'
      title = 'Edit Book'
    }
    this.bookDialog = {
      actionType,
      show: true,
      title,
      disable: false,
      highlightTitle
    }
  }

  hideBookDialog () {
    this.targetBook = null
    this.bookDialog = {
      actionType: 'new',
      show: false,
      title: 'New Book',
      disable: false,
      highlightTitle: ''
    }
  }

  async deleteBook (e: Event, targetBook: Book) {
    e.preventDefault()
    e.stopPropagation()
    this.targetBook = targetBook
    this.deleteBookDialog.show = true
  }

  async deleteBookPost () {
    if (!this.targetBook) {
      return
    }
    const { id } = this.targetBook
    this.deleteBookDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteBook,
        variables: {
          bookId: Number(id)
        }
      })

      const res = result.data.deleteBook
      if (res) {
        showNotification({
          msg: 'Delete general agent successfully',
          type: SnackType.Success
        })
        this.targetBook = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
